import React, {
  useEffect,
  useState,
  ComponentProps,
} from "react";
import { FiatCurrency } from "@nestcoinco/hyper-api-gateway-api-client";

import "./LatestWinsSlider.scss";
import LatestWinItem from "../LatestWinItem/LatestWinItem";
import { fetchIpInfo } from "../../../utils/helpers";
import { IpInfoCountry } from "../../../types";
import useLatestWinnersQuery from "../../../react-query/queries/use-latest-winners";

const ITEM_FLIP_INTERVAL = 3000;

function LatestWinsSlider({ className = "", ...props }: ComponentProps<"div">) {
  const [indexOfItemInView, setIndexOfItemInView] = useState(0);
  const [selectedCurrency, setSelectedCurrency] = useState<FiatCurrency>(
    FiatCurrency.NGN,
  );
  const { latestWinners } = useLatestWinnersQuery();
  const winnerCount = latestWinners?.records.length ?? 0;

  useEffect(() => {
    if (!winnerCount) return;

    setIndexOfItemInView((currentIndex) =>
      currentIndex < winnerCount ? currentIndex : 0
    );
    const intervalId = setInterval(() => {
      setIndexOfItemInView(
        (currentIndex) => (currentIndex + 1) % winnerCount
      );
    }, ITEM_FLIP_INTERVAL);

    return () => {
      clearInterval(intervalId);
    };
  }, [winnerCount]);

  useEffect(() => {
    const getCurrentCountry = async () => {
      const currentCountry = (await fetchIpInfo())?.country;
      if (currentCountry && currentCountry !== IpInfoCountry.NG) {
        setSelectedCurrency(FiatCurrency.USD);
        return;
      }
      setSelectedCurrency(FiatCurrency.NGN);
    };

    getCurrentCountry();
  }, []);

  if (!latestWinners?.records?.length) return null;

  return (
    <div className={`latest-wins-slider-container ${className}`} {...props}>
      {latestWinners?.records?.length &&
        latestWinners.records.map((latestWinner, i) => (
          <LatestWinItem
            key={i}
            indexOfItemInView={indexOfItemInView}
            index={i}
            winner={latestWinner}
            selectedCurrency={selectedCurrency}
          />
        ))}
    </div>
  );
}

export default LatestWinsSlider;
